import { classInstance, clickOutside, enableScroll, disableScroll } from '@/shared/helpers/helpers';

const navDrawerSelector = '.js-nav-drawer';

class NavDrawer {
	static openDrawers = [];
	static overlay = document.querySelector(`.js-nav-drawer-overlay`);
	static resizeListener = null;

	constructor(drawer) {
		this.drawer = drawer;
		this.buttons = document.querySelectorAll(
			`.js-nav-toggler[data-drawer="${drawer.dataset.drawer}"]`,
		);
		this.closeButton = this.drawer.querySelector(`.js-nav-drawer-close`);
		this.smallMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);

		this.bindEvents();
	}

	toggle = (e) => {
		const modalElement = classInstance.get(document.querySelector(`.js-modal.active`));
		const modalLayer = document.querySelector(`.js-modal-layer`);
		modalElement?.modal.close();
		modalLayer?.classList.remove('active');

		NavDrawer.openDrawers.forEach((drawer) => {
			drawer !== this && drawer.close();
		});
		e.currentTarget.classList.toggle('is-active');
		this.drawer.classList.toggle('is-active');
		NavDrawer.overlay?.classList.toggle('is-visible');
		if (this.drawer.classList.contains('is-active')) {
			!this.smallMQ.matches &&
				!document.body.classList.contains('disable-scroll') &&
				disableScroll();
			!NavDrawer.openDrawers.includes(this) && NavDrawer.openDrawers.push(this);
		} else {
			!this.smallMQ.matches && enableScroll();
			NavDrawer.openDrawers = [];
			NavDrawer.overlay?.classList.remove('is-visible');
			this.dispatchClose();
		}
		if (!NavDrawer.resizeListener) {
			window.addEventListener('resize', NavDrawer.closeAll, { once: true });
			NavDrawer.resizeListener = true;
		}
	};

	close = () => {
		this.buttons.forEach((button) => button.classList.remove('is-active'));
		this.drawer.classList.remove('is-active');
		NavDrawer.overlay?.classList.remove('is-visible');
		NavDrawer.openDrawers = [];
		NavDrawer.resizeListener = false;
		!this.smallMQ.matches && enableScroll();

		this.dispatchClose();
	};

	dispatchClose = () => {
		this.drawer.dispatchEvent(new CustomEvent('navDrawerClose', { detail: { drawer: this } }));
	};

	static closeAll = () => {
		[...NavDrawer.openDrawers].forEach((drawer) => drawer.close());
	};

	bindEvents() {
		this.buttons.forEach((button) => button.addEventListener('click', this.toggle));
		this.closeButton?.addEventListener('click', this.close);
		NavDrawer.overlay?.addEventListener('click', NavDrawer.closeAll);
		window.addEventListener('click', (e) => {
			const activeDrawer = this.drawer.classList.contains('is-active');
			const isButtonClick = Array.from(this.buttons).some((button) => button.contains(e.target));
			if (this.smallMQ.matches && !isButtonClick && clickOutside(e, this.drawer)) {
				activeDrawer && this.close();
			}
		});
	}
}

export default class InitNavDrawer {
	constructor() {
		this.init();
	}

	init() {
		const navDrawers = document.querySelectorAll(navDrawerSelector);
		navDrawers.forEach((navDrawer) => new NavDrawer(navDrawer));
	}
}

function expandOuterMobileSectionCollapse(targetEl) {
	const collapseRoot = targetEl.matches('[data-mobile-collapse]')
		? targetEl
		: targetEl.closest('[data-mobile-collapse]');
	if (!collapseRoot) return 0;
	const outerEl = collapseRoot.querySelector(':scope > .js-collapse__element');
	if (!outerEl || outerEl.classList.contains('shown')) return 0;
	const inst = window.app.classInstance.get(collapseRoot)?.collapse;
	if (!inst) return 0;
	inst.open(outerEl);
	const raw = collapseRoot.dataset?.duration;
	const parsed = raw != null ? parseInt(String(raw), 10) : NaN;
	return Number.isFinite(parsed) && parsed >= 0 ? parsed + 50 : 250;
}

function onDrawerAnchorClick(event) {
	const link = event.currentTarget;
	const href = link.getAttribute('href');
	if (!href || href === '#' || href.length < 2) return;

	const hash = href.startsWith('/#') ? href.slice(1) : href;
	if (!hash.startsWith('#') || hash.length < 2) return;

	const target = document.getElementById(hash.slice(1));
	if (!target) return;

	event.preventDefault();

	NavDrawer.closeAll();

	const mobile = !window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`).matches;
	const scrollDelay = mobile ? expandOuterMobileSectionCollapse(target) : 0;

	const scrollToTarget = () => {
		target.scrollIntoView({ block: 'start', behavior: 'smooth' });
	};

	if (scrollDelay > 0) {
		window.setTimeout(scrollToTarget, scrollDelay);
	} else {
		scrollToTarget();
	}
}

export function closeAllNavDrawers() {
	NavDrawer.closeAll();
}

export function initNavDrawerAnchors() {
	document
		.querySelectorAll('.js-nav-drawer a[href^="#"], .js-nav-drawer a[href^="/#"]')
		.forEach((anchor) => {
			if (anchor.getAttribute('href') === '#') return;
			anchor.addEventListener('click', onDrawerAnchorClick);
		});
}
